export enum REQUEST_FREQUENCY_TYPE {
  SIN_FRECUENCIA = 0,
  POR_HORAS = 1,
  POR_DIAS = 2,
  POR_MESES = 3
}

export enum REQUEST_CATEGORY {
  PERMISOS = 1,
  VACACIONES = 2,
  LICENCIAS = 3,
  HORAS_ADICIONALES = 4,
  DESCUENTOS = 5,
  REGULARIZACION_MARCAS = 6
}

export enum REQUEST_REASON_TYPE {
  MOTIVOS_PERSONALES = 4,
  MOTIVOS_MEDICOS = 6,
  MOTIVOS_ACADEMICOS = 13,
  OTROS = 17
}